import { Box } from '@mui/system';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import TController from './components/view/TController';
const View = () => {
  const { id } = useParams();
  const [moduleData, setModuleData] = useState<any>();
  useEffect(() => {
    if (id) {
      axios
        .get(`/api/tni/getOneTopicPaper/${id}`)
        .then((res) => {
          setModuleData(res.data);
        })
        .catch((err) => console.log(err));
    }
  }, [id]);

  return (
    <Box>
      <TController {...{ moduleData }} />
    </Box>
  );
};

export default View;
